"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconSize = exports.IconSizes = exports.rgsViewBox = exports.defaultViewBox = void 0;
exports.defaultViewBox = '0 0 28 28';
exports.rgsViewBox = '0 0 64 64';
var IconSizes;
(function (IconSizes) {
    IconSizes["large"] = "large";
    IconSizes["medium"] = "medium";
    IconSizes["small"] = "small";
    IconSizes["rgs"] = "rgs";
})(IconSizes = exports.IconSizes || (exports.IconSizes = {}));
exports.getIconSize = {
    [IconSizes.large]: '84px',
    [IconSizes.medium]: '28px',
    [IconSizes.small]: '12px',
    [IconSizes.rgs]: '64px',
};
